import {Button} from '@mui/material';
import {useTheme} from '@mui/material/styles';
import PropTypes from 'prop-types';
import React, {useState} from 'react';

import ShareDocumentModal from './ShareDocument/ShareDocumentModal';

const ShareDocumentButton = ({documentId, isPdfReviewDoc = false}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const theme = useTheme();

  const handleClose = (_, reason) => {
    if (reason !== 'backdropClick') {
      setModalOpen(false);
    }
  };

  return (
    <>
      <Button
        disabled={!documentId}
        onClick={() => setModalOpen(true)}
        size="small"
        sx={{...theme.button.secondary.medium, whiteSpace: 'nowrap'}}
        variant="contained"
      >
        Share
      </Button>
      <ShareDocumentModal
        documentId={documentId}
        onClose={handleClose}
        open={modalOpen}
        isPdfReviewDoc={isPdfReviewDoc}
      />
    </>
  );
};

ShareDocumentButton.propTypes = {
  documentId: PropTypes.string.isRequired,
  isPdfReviewDoc: PropTypes.bool,
};

export default ShareDocumentButton;
